<template>
  <div class="container-fluid" id="order-details">
    <div class="row">
      <div class="col-lg-12">
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
          <div class="d-flex align-items-center justify-content-between">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb p-0 mb-0">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'my-rfps' }">RFP</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  RFP Details
                </li>
              </ol>
            </nav>
          </div>
          <div class="d-flex">
            <div>
              <button class="btn btn-info btn-sm ml-2" style="cursor: pointer" @click="handleUpload">
                <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd"
                  clip-rule="evenodd" fill="white">
                  <path
                    d="M11.492 10.172l-2.5 3.064-.737-.677 3.737-4.559 3.753 4.585-.753.665-2.5-3.076v7.826h-1v-7.828zm7.008 9.828h-13c-2.481 0-4.5-2.018-4.5-4.5 0-2.178 1.555-4.038 3.698-4.424l.779-.14.043-.789c.185-3.448 3.031-6.147 6.48-6.147 3.449 0 6.295 2.699 6.478 6.147l.044.789.78.14c2.142.386 3.698 2.246 3.698 4.424 0 2.482-2.019 4.5-4.5 4.5m.978-9.908c-.212-3.951-3.472-7.092-7.478-7.092s-7.267 3.141-7.479 7.092c-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.522-5.408" />
                </svg>
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="main-div">
      <div class="row">
        <div class="col-md-4">
          <div class="card">
            <ul class="list-group list-group-flush">
              <li class="list-group-item p-3">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                  <h5 class="font-weight-bold pb-2">RFP Info</h5>
                </div>
                <div class="table-responsive">
                  <table class="table table-borderless mb-0">
                    <tbody>
                      <tr class="white-space-no-wrap">
                        <td class="text-muted pl-0">Number</td>
                        <td class="order-id" id="order_id">
                          {{ this.rfpId }}
                          <span @click.prevent="copyIdToClipboard(rfpId)" class="ml-1 cursor-pointer">
                            <svg v-b-tooltip.top title="Click to Copy" fill="#158df7cc" width="20" height="20"
                              clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                              viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="m6 18h-3c-.48 0-1-.379-1-1v-14c0-.481.38-1 1-1h14c.621 0 1 .522 1 1v3h3c.621 0 1 .522 1 1v14c0 .621-.522 1-1 1h-14c-.48 0-1-.379-1-1zm1.5-10.5v13h13v-13zm9-1.5v-2.5h-13v13h2.5v-9.5c0-.481.38-1 1-1z"
                                fill-rule="nonzero" />
                            </svg>
                          </span>
                        </td>
                      </tr>

                      <tr class="white-space-no-wrap" v-if="order.order">
                        <td class="text-muted pl-0">Order Number</td>
                        <td class="order-id" id="order_id">
                          {{ order.order ? order.order.number : ' - ' }}
                          <span @click.prevent="copyIdToClipboard(order.order.number)" class="ml-1 cursor-pointer">
                            <svg v-b-tooltip.top title="Click to Copy" fill="#158df7cc" width="20" height="20"
                              clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                              viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="m6 18h-3c-.48 0-1-.379-1-1v-14c0-.481.38-1 1-1h14c.621 0 1 .522 1 1v3h3c.621 0 1 .522 1 1v14c0 .621-.522 1-1 1h-14c-.48 0-1-.379-1-1zm1.5-10.5v13h13v-13zm9-1.5v-2.5h-13v13h2.5v-9.5c0-.481.38-1 1-1z"
                                fill-rule="nonzero" />
                            </svg>
                          </span>
                        </td>
                      </tr>

                      <tr class="white-space-no-wrap">
                        <td class="text-muted pl-0 edit-label">Is Fully Quoted</td>
                        <td>
                          <div class="d-flex">
                            <div v-if="order.isFullyQuoted === false" class="mr-2">
                              <svg xmlns="http://www.w3.org/2000/svg" fill="red" width="18" height="18"
                                viewBox="0 0 24 24">
                                <path
                                  d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.151 17.943l-4.143-4.102-4.117 4.159-1.833-1.833 4.104-4.157-4.162-4.119 1.833-1.833 4.155 4.102 4.106-4.16 1.849 1.849-4.1 4.141 4.157 4.104-1.849 1.849z" />
                              </svg>
                            </div>
                            <div v-else class="mr-2">
                              <svg xmlns="http://www.w3.org/2000/svg" fill="green" width="18" height="18"
                                viewBox="0 0 24 24">
                                <path
                                  d="M23.334 11.96c-.713-.726-.872-1.829-.393-2.727.342-.64.366-1.401.064-2.062-.301-.66-.893-1.142-1.601-1.302-.991-.225-1.722-1.067-1.803-2.081-.059-.723-.451-1.378-1.062-1.77-.609-.393-1.367-.478-2.05-.229-.956.347-2.026.032-2.642-.776-.44-.576-1.124-.915-1.85-.915-.725 0-1.409.339-1.849.915-.613.809-1.683 1.124-2.639.777-.682-.248-1.44-.163-2.05.229-.61.392-1.003 1.047-1.061 1.77-.082 1.014-.812 1.857-1.803 2.081-.708.16-1.3.642-1.601 1.302s-.277 1.422.065 2.061c.479.897.32 2.001-.392 2.727-.509.517-.747 1.242-.644 1.96s.536 1.347 1.17 1.7c.888.495 1.352 1.51 1.144 2.505-.147.71.044 1.448.519 1.996.476.549 1.18.844 1.902.798 1.016-.063 1.953.54 2.317 1.489.259.678.82 1.195 1.517 1.399.695.204 1.447.072 2.031-.357.819-.603 1.936-.603 2.754 0 .584.43 1.336.562 2.031.357.697-.204 1.258-.722 1.518-1.399.363-.949 1.301-1.553 2.316-1.489.724.046 1.427-.249 1.902-.798.475-.548.667-1.286.519-1.996-.207-.995.256-2.01 1.145-2.505.633-.354 1.065-.982 1.169-1.7s-.135-1.443-.643-1.96zm-12.584 5.43l-4.5-4.364 1.857-1.857 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.642z" />
                              </svg>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr v-if="order.createdAt">
                        <td class="p-0">
                          <p class="mb-0 text-muted">Created At</p>
                        </td>
                        <td>
                          {{ order.createdAt | DateTimeFormat }}

                        </td>
                      </tr>

                      <tr v-if="order.notes">
                        <td class="text-muted pl-0">Parts Notes</td>
                        <td style="white-space: pre-wrap; line-height: 1.5;">{{ order.notes }}</td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </li>
            </ul>
          </div>
          <div class="card">
            <ul class="list-group list-group-flush">
              <li class="list-group-item p-3 d-flex justify-content-between">
                <h5 class="font-weight-bold">Enquiries</h5>
              </li>
              <li class="list-group-item p-0">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr class="text-muted">
                        <th scope="col" class="text-monospace">Section</th>
                        <th scope="col" class="text-monospace">Position</th>
                        <th scope="col" class="text-monospace">Details</th>
                        <th scope="col" class="text-monospace">Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in order.enquiries" :key="index">
                        <td class="text-monospace"
                          style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
                          :title="item.section || '-'">
                          {{ item.section || '-' }}
                        </td>
                        <td class="text-monospace">
                          {{ getPositionName(item.position) }}
                        </td>
                        <td class="text-monospace">
                          {{ item.details }}
                        </td>
                        <td class="text-monospace">
                          {{ item.quantity }}
                          <span v-if="item.quantity === 0" :title="`Kindly check the quantity as per the given VIN
and quote accordingly`" class="badge badge-warning ml-1">TBC</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-md-8">
          <div class="row">
            <div class="col-md-6">
              <div class="card">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item p-3">
                    <h5 class="font-weight-bold pb-2">Car Info</h5>
                    <div class="table-responsive">
                      <table class="table table-borderless mb-0">
                        <tbody v-if="order.car">
                          <tr class="">
                            <td class="text-muted pl-0 edit-label">Model</td>
                            <td colspan="3">
                              {{
                                order.car.model.make.name +
                                " " +
                                order.car.model.name
                              }}
                              <router-link v-if="order.customer" class="navigation-link-text" :to="{
                                path:
                                  '/car/edit/' +
                                  order.car.id +
                                  '/' +
                                  order.customer.phone,
                              }">
                                <svg xmlns="http://www.w3.org/2000/svg" class="text-secondary mx-1 job-info-svg"
                                  width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                </svg>
                              </router-link>
                            </td>
                          </tr>
                          <tr class="white-space-no-wrap">
                            <td class="text-muted pl-0">Year</td>
                            <td>{{ order.car.year }}</td>
                            <td class="text-muted pl-0">VIN</td>
                            <td class="white-space-no-wrap" style="font-size: smaller;" id="vin_number">
                              <span v-if="order.car.vin" @click.prevent="
                                copyTextToClipboard(order.car.vin, 'Vin')
                                " class="ml-1 cursor-pointer">
                                <svg v-b-tooltip.top title="Click to Copy" fill="#158df7cc" width="20" height="20"
                                  clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="m6 18h-3c-.48 0-1-.379-1-1v-14c0-.481.38-1 1-1h14c.621 0 1 .522 1 1v3h3c.621 0 1 .522 1 1v14c0 .621-.522 1-1 1h-14c-.48 0-1-.379-1-1zm1.5-10.5v13h13v-13zm9-1.5v-2.5h-13v13h2.5v-9.5c0-.481.38-1 1-1z"
                                    fill-rule="nonzero" />
                                </svg>
                              </span>
                              {{ order.car.vin || " - " }}
                            </td>
                          </tr>
                          <tr>
                            <td class="text-muted pl-0">Plate No.</td>
                            <td id="license_plate">
                              <span v-if="order.car.licensePlate" @click.prevent="
                                copyTextToClipboard(
                                  order.car.licensePlate,
                                  'License Plate'
                                )
                                " class="ml-1 cursor-pointer">
                                <svg v-b-tooltip.top title="Click to Copy" fill="#158df7cc" width="20" height="20"
                                  clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="m6 18h-3c-.48 0-1-.379-1-1v-14c0-.481.38-1 1-1h14c.621 0 1 .522 1 1v3h3c.621 0 1 .522 1 1v14c0 .621-.522 1-1 1h-14c-.48 0-1-.379-1-1zm1.5-10.5v13h13v-13zm9-1.5v-2.5h-13v13h2.5v-9.5c0-.481.38-1 1-1z"
                                    fill-rule="nonzero" />
                                </svg>
                                {{ order.car.licensePlate || " - " }}
                              </span>
                            </td>
                            <td class="text-muted pl-0" title="Classification">Classn.</td>
                            <td>{{
                              order.car.classification
                                ? order.car.classification
                                : " - "
                            }}</td>
                          </tr>
                          <tr v-if="order.car && order.car.registrationCard && order.car.registrationCard.front"
                            class="white-space-no-wrap">
                            <td class="text-muted pl-0" title="Registration Card">Regn. Card</td>
                            <td colspan="3">
                              <button class="btn btn-primary btn-sm mr-1" @click="handleRegistrationCardFront">
                                <svg width="18" height="18" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"
                                  fill="#ffffff">
                                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                  <g id="SVGRepo_iconCarrier">
                                    <path fill="#ffffff"
                                      d="M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352zm0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288zm0 64a224 224 0 1 1 0 448 224 224 0 0 1 0-448zm0 64a160.192 160.192 0 0 0-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160z">
                                    </path>
                                  </g>
                                </svg>
                                Front
                              </button>
                              <button class="btn btn-primary btn-sm mr-1" @click="handleRegistrationCardBack"
                                :disabled="!order.car.registrationCard.back">
                                <svg width="18" height="18" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"
                                  fill="#ffffff">
                                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                  <g id="SVGRepo_iconCarrier">
                                    <path fill="#ffffff"
                                      d="M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352zm0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288zm0 64a224 224 0 1 1 0 448 224 224 0 0 1 0-448zm0 64a160.192 160.192 0 0 0-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160z">
                                    </path>
                                  </g>
                                </svg>
                                Back
                              </button>
                            </td>
                          </tr>
                          <tr v-if="order.car.mileage">
                            <td class="text-muted pl-0">Mileage</td>
                            <td>{{ order.car.mileage }}</td>
                            <td class="text-muted pl-0" title="Mileage Updated At">Updt.</td>
                            <td style="font-size: smaller;" :title="order.car.mileageUpdatedAt">{{
                              order.car.mileageUpdatedAt | DateTimeFormat }}</td>
                          </tr>
                          <tr v-if="order.car.nextServiceMileage || order.car.nextServiceDue">
                            <td class="text-muted pl-0" title="Next Service Mileage">Next Svc.</td>
                            <td>{{ order.car.nextServiceMileage }}</td>
                            <td class="text-muted pl-0" title="Next Service Due On">Svc. Due</td>
                            <td style="font-size: smaller;" :title="order.car.nextServiceDue">{{
                              order.car.nextServiceDue | DateFormat }}</td>
                          </tr>
                          <tr v-if="order.car.insuranceRenewalAt || order.car.registrationRenewalAt">
                            <td class="text-muted pl-0" title="Insurance Renewal On">Insur. Ren.</td>
                            <td style="font-size: smaller;" :title="order.car.insuranceRenewalAt">{{
                              order.car.insuranceRenewalAt | DateFormat }}</td>
                            <td class="text-muted pl-0" title="Registration Renewal On">Reg. Ren.</td>
                            <td style="font-size: smaller;" :title="order.car.registrationRenewalAt">{{
                              order.car.registrationRenewalAt | DateFormat }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="card">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item p-3">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="font-weight-bold pb-2">Comments</h5>
                      <div class="btn btn-success btn-sm" title="Add Comment">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="none" viewBox="0 0 24 24"
                          stroke="currentColor" @click="handleComment()">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                        </svg>
                      </div>
                    </div>
                    <div class="table-responsive commentScroll" v-if="order.comments && order.comments.length > 0">
                      <div v-for="(item, index) in order.comments" :key="index">
                        <div v-bind:class="item.isWhisper == true ? 'orange-highlight' : ''
                          " style="padding: 8px">
                          <div v-if="item.createdBy">
                            <span style="
                              font-size: 16px;
                              font-weight: bold;
                              color: black;
                            ">{{ item.createdBy.firstName }}</span>
                            -
                            <span style="font-size: 12px" :title="order.createdAt">{{
                              item.createdAt | DateTimeFormat
                              }}</span>
                          </div>
                          <div v-else>
                            <span style="font-size: 12px" :title="order.createdAt">{{
                              item.createdAt | DateTimeFormat
                              }}</span>
                          </div>
                          <div class="comments" style="font-size: 16px">{{ item.comment }}</div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="p-3" style="text-align: center">
                      No Comments
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item p-3 d-flex flex-wrap justify-content-between">
                    <h5 class="font-weight-bold">Attachments</h5>
                  </li>
                  <div>
                    <div class="divScroll" v-if="order.attachments && order.attachments.length > 0">
                      <div v-for="(file, index) in order.attachments" v-bind:key="index">
                        <div style="
                            display: flex;
                            align-items: center;
                            padding: 7px 15px;
                          ">
                          <div style="display: block">
                            <a class="mr-2" :href="file.file" target="_blank">
                              <img v-if="
                                file.extension == 'png' ||
                                file.extension == 'jpeg' ||
                                file.extension == 'jpg'
                              " :src="file.file" class="img-fluid rounded-normal" width="140px" alt="logo" />
                              <svg v-else-if="file.extension == 'pdf'" height="80" width="100" version="1.1" id="Capa_1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 56 56" xml:space="preserve">
                                <g>
                                  <path style="fill: #e9e9e0"
                                    d="M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074
      c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z" />
                                  <polygon style="fill: #d9d7ca" points="37.5,0.151 37.5,12 49.349,12 	" />
                                  <path style="fill: #cc4b4c" d="M19.514,33.324L19.514,33.324c-0.348,0-0.682-0.113-0.967-0.326
      c-1.041-0.781-1.181-1.65-1.115-2.242c0.182-1.628,2.195-3.332,5.985-5.068c1.504-3.296,2.935-7.357,3.788-10.75
      c-0.998-2.172-1.968-4.99-1.261-6.643c0.248-0.579,0.557-1.023,1.134-1.215c0.228-0.076,0.804-0.172,1.016-0.172
      c0.504,0,0.947,0.649,1.261,1.049c0.295,0.376,0.964,1.173-0.373,6.802c1.348,2.784,3.258,5.62,5.088,7.562
      c1.311-0.237,2.439-0.358,3.358-0.358c1.566,0,2.515,0.365,2.902,1.117c0.32,0.622,0.189,1.349-0.39,2.16
      c-0.557,0.779-1.325,1.191-2.22,1.191c-1.216,0-2.632-0.768-4.211-2.285c-2.837,0.593-6.15,1.651-8.828,2.822
      c-0.836,1.774-1.637,3.203-2.383,4.251C21.273,32.654,20.389,33.324,19.514,33.324z M22.176,28.198
      c-2.137,1.201-3.008,2.188-3.071,2.744c-0.01,0.092-0.037,0.334,0.431,0.692C19.685,31.587,20.555,31.19,22.176,28.198z
      M35.813,23.756c0.815,0.627,1.014,0.944,1.547,0.944c0.234,0,0.901-0.01,1.21-0.441c0.149-0.209,0.207-0.343,0.23-0.415
      c-0.123-0.065-0.286-0.197-1.175-0.197C37.12,23.648,36.485,23.67,35.813,23.756z M28.343,17.174
      c-0.715,2.474-1.659,5.145-2.674,7.564c2.09-0.811,4.362-1.519,6.496-2.02C30.815,21.15,29.466,19.192,28.343,17.174z
      M27.736,8.712c-0.098,0.033-1.33,1.757,0.096,3.216C28.781,9.813,27.779,8.698,27.736,8.712z" />
                                  <path style="fill: #cc4b4c"
                                    d="M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z" />
                                  <g>
                                    <path style="fill: #ffffff" d="M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205
        c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306
        c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656
        s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103
        c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032
        c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492
        c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z" />
                                    <path style="fill: #ffffff" d="M32.219,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937
        s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C28.222,52.984,28.026,53,27.898,53h-3.814V42.924h3.035
        c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C32.114,46.494,32.219,47.08,32.219,47.682z
        M27.352,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244
        c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H27.352z" />
                                    <path style="fill: #ffffff"
                                      d="M36.266,44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244H36.266z" />
                                  </g>
                                </g>
                              </svg>
                              <svg v-else-if="file.extension == 'xlsx'" height="80" width="100" viewBox="0 0 32 32"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                fill="#000000">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                  <defs>
                                    <linearGradient id="a" x1="4.494" y1="-2092.086" x2="13.832" y2="-2075.914"
                                      gradientTransform="translate(0 2100)" gradientUnits="userSpaceOnUse">
                                      <stop offset="0" stop-color="#18884f"></stop>
                                      <stop offset="0.5" stop-color="#117e43"></stop>
                                      <stop offset="1" stop-color="#0b6631"></stop>
                                    </linearGradient>
                                  </defs>
                                  <title>file_type_excel</title>
                                  <path
                                    d="M19.581,15.35,8.512,13.4V27.809A1.192,1.192,0,0,0,9.705,29h19.1A1.192,1.192,0,0,0,30,27.809h0V22.5Z"
                                    style="fill: #185c37"></path>
                                  <path
                                    d="M19.581,3H9.705A1.192,1.192,0,0,0,8.512,4.191h0V9.5L19.581,16l5.861,1.95L30,16V9.5Z"
                                    style="fill: #21a366"></path>
                                  <path d="M8.512,9.5H19.581V16H8.512Z" style="fill: #107c41"></path>
                                  <path
                                    d="M16.434,8.2H8.512V24.45h7.922a1.2,1.2,0,0,0,1.194-1.191V9.391A1.2,1.2,0,0,0,16.434,8.2Z"
                                    style="
                                      opacity: 0.10000000149011612;
                                      isolation: isolate;
                                    "></path>
                                  <path
                                    d="M15.783,8.85H8.512V25.1h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
                                    style="
                                      opacity: 0.20000000298023224;
                                      isolation: isolate;
                                    "></path>
                                  <path
                                    d="M15.783,8.85H8.512V23.8h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
                                    style="
                                      opacity: 0.20000000298023224;
                                      isolation: isolate;
                                    "></path>
                                  <path
                                    d="M15.132,8.85H8.512V23.8h6.62a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.132,8.85Z"
                                    style="
                                      opacity: 0.20000000298023224;
                                      isolation: isolate;
                                    "></path>
                                  <path
                                    d="M3.194,8.85H15.132a1.193,1.193,0,0,1,1.194,1.191V21.959a1.193,1.193,0,0,1-1.194,1.191H3.194A1.192,1.192,0,0,1,2,21.959V10.041A1.192,1.192,0,0,1,3.194,8.85Z"
                                    style="fill: url(#a)"></path>
                                  <path
                                    d="M5.7,19.873l2.511-3.884-2.3-3.862H7.758L9.013,14.6c.116.234.2.408.238.524h.017c.082-.188.169-.369.26-.546l1.342-2.447h1.7l-2.359,3.84,2.419,3.905H10.821l-1.45-2.711A2.355,2.355,0,0,1,9.2,16.8H9.176a1.688,1.688,0,0,1-.168.351L7.515,19.873Z"
                                    style="fill: #fff"></path>
                                  <path d="M28.806,3H19.581V9.5H30V4.191A1.192,1.192,0,0,0,28.806,3Z"
                                    style="fill: #33c481"></path>
                                  <path d="M19.581,16H30v6.5H19.581Z" style="fill: #107c41"></path>
                                </g>
                              </svg>
                              <svg v-else fill="#0D5FFF" height="80" width="100" viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                                <path
                                  d="M22 24h-20v-24h14l6 6v18zm-7-23h-12v22h18v-16h-6v-6zm3 15v1h-12v-1h12zm0-3v1h-12v-1h12zm0-3v1h-12v-1h12zm-2-4h4.586l-4.586-4.586v4.586z" />
                              </svg>
                            </a>
                            <div style="font-size: 10px; word-break: break-all; max-width: 150px;" title="Filename">{{
                              file.filename }}</div>
                            <div class="d-flex justify-content-between" style="font-size: 12px; width: 100px">
                              <div v-if="file.uploadedBy">
                                By: {{ file.uploadedBy.firstName }}
                              </div>

                            </div>
                            <div style="font-size: 12px" :title="file.uploadedAt">
                              {{ file.uploadedAt | DateTimeFormat }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="p-3" style="text-align: center">
                      No Images
                    </div>
                  </div>
                </ul>
              </div>
            </div>
          </div>

        </div>

        <!-- Registration Card Front -->
        <b-modal v-model="registrationFrontModalShow" id="frontModal" centered title="Registration Card Front" size="lg"
          hide-footer hide-header>
          <div v-if="order.car && order.car.registrationCard && order.car.registrationCard.front">
            <img width="100%" :src="order.car.registrationCard.front" alt="Popup Image" />
          </div>
        </b-modal>

        <!-- Registration Card Back -->
        <b-modal v-model="registrationBackModalShow" id="backModal" centered title="Registration Card Back" size="lg"
          hide-footer hide-header>
          <div v-if="order.car && order.car.registrationCard && order.car.registrationCard.back">
            <img width="100%" :src="order.car.registrationCard.back" alt="Popup Image" />
          </div>
        </b-modal>

        <!-- Upload -->
        <b-modal v-model="uploadModalShow" id="modal-center" centered title="Attachments">
          <div class="d-flex justify-content-between">
            <div class="row" style="padding: 10px">
              <div class="col-md-12 mb-3" id="app">
                <div class="inputWrapper" style="width: 162px">
                  <button class="btn btn-primary btn-sm" style="font-size: medium; cursor: pointer">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd"
                      clip-rule="evenodd" fill="white" style="margin-right: 10px">
                      <path
                        d="M11.492 10.172l-2.5 3.064-.737-.677 3.737-4.559 3.753 4.585-.753.665-2.5-3.076v7.826h-1v-7.828zm7.008 9.828h-13c-2.481 0-4.5-2.018-4.5-4.5 0-2.178 1.555-4.038 3.698-4.424l.779-.14.043-.789c.185-3.448 3.031-6.147 6.48-6.147 3.449 0 6.295 2.699 6.478 6.147l.044.789.78.14c2.142.386 3.698 2.246 3.698 4.424 0 2.482-2.019 4.5-4.5 4.5m.978-9.908c-.212-3.951-3.472-7.092-7.478-7.092s-7.267 3.141-7.479 7.092c-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.522-5.408" />
                    </svg>
                    Choose File(s)
                    <input class="fileInput hidden" @change="handleFileUpload" multiple type="file" name="file3" />
                  </button>
                </div>
                <br />
                <div v-if="files.length > 0">
                  <div class="divScroll" style="border: 1px solid grey">
                    <div class="img-tag" v-for="(file, index) in files" v-bind:key="file.name">
                      <div style="display: flex; align-items: center">
                        <div class="mr-2 ml-1">{{ file.name }}</div>
                        <svg clip-rule="evenodd" fill="red" width="18" height="18" fill-rule="evenodd"
                          stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg" @click="removeImage(index)">
                          <path
                            d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <template #modal-footer>
            <div class="w-100">
              <button variant="success" size="sm" class="btn btn-success float-right btn-sm"
                style="font-size: medium; cursor: pointer" @click="orderUpload">
                Upload
              </button>
            </div>
          </template>
        </b-modal>

        <!-- Add Comment -->
        <b-modal v-model="commentModalShow" id="modal-comment" centered title="Add Comment" size="md">
          <div>
            <div class="col-md-12 mb-3">
              <label for="car-model" class="form-label font-weight-bold text-muted">
                Comment *
              </label>
              <div>
                <textarea rows="4" class="custom-input" type="text" v-model="comment"></textarea>
              </div>
            </div>
          </div>

          <template #modal-footer>
            <div class="w-100">
              <b-button variant="primary" size="sm" class="float-right order-add" @click="commentUpdate">
                Submit
              </b-button>
            </div>
          </template>
        </b-modal>
      </div>


      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <ul class="list-group list-group-flush">
              <li class="list-group-item p-3 d-flex justify-content-between">
                <h5 class="font-weight-bold">Part Quotations</h5>
                <div class="d-flex align-items-start">
                  <div class="d-flex flex-wrap align-items-center mr-3">
                    <label for="car-make" class="
                          form-label
                          text-muted
                          filter-label-heading
                          white-space
                          mt-1
                          mr-2
                        ">Show Deleted
                    </label>
                    <b-form-checkbox id="is-quoted" size="lg" v-model="checkedShowExpired" @input="handleShowExpired"
                      name="check-button" switch style="margin-right: 10px"
                      :class="{ 'borderColorFilter': showExpired, 'is-true': true }">
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex flex-wrap align-items-start mr-3" style="width: 200px;">
                    <multiselect v-model="selectedPartQualities" :options="partQualityFilterOptions" :multiple="true"
                      :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                      placeholder="Select Quality" label="name" track-by="value" :show-labels="false"
                      @input="handlePartQualityFilter">
                    </multiselect>
                  </div>
                  <div class="d-flex flex-wrap align-items-start mr-3" style="width: 200px;">
                    <multiselect v-model="selectedCreatedBy" :options="createdByOptions" :multiple="true"
                      :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Created By"
                      label="name" track-by="id" :show-labels="false" @input="handleCreatedByFilter">
                    </multiselect>
                  </div>
                  <div class="d-flex flex-wrap align-items-start mr-3" style="width: 200px;">
                    <multiselect v-model="selectedSections" :options="sectionFilterOptions" :multiple="true"
                      :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Section"
                      :show-labels="false" @input="handleSectionFilter">
                    </multiselect>
                  </div>
                  <button class="btn btn-warning btn-sm mr-2" @click="copyAllPartQuotationToClipboard"
                    style="font-size: 16px">
                    <svg v-b-tooltip.top title="Click to Copy" fill="#fff" width="20" height="20" clip-rule="evenodd"
                      fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="m6 18h-3c-.48 0-1-.379-1-1v-14c0-.481.38-1 1-1h14c.621 0 1 .522 1 1v3h3c.621 0 1 .522 1 1v14c0 .621-.522 1-1 1h-14c-.48 0-1-.379-1-1zm1.5-10.5v13h13v-13zm9-1.5v-2.5h-13v13h2.5v-9.5c0-.481.38-1 1-1z"
                        fill-rule="nonzero" />
                    </svg>
                    Copy All
                  </button>
                  <button class="btn btn-primary btn-sm" @click="addPartQuotation" style="font-size: 16px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="none" viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6">
                      </path>
                    </svg>
                    Add Quote
                  </button>
                </div>
              </li>
              <div class="">
                <div class="p-2">
                  <div style="max-height: 400px" class="table-responsive table-zoom" v-if="
                    partQuotations && partQuotations.length > 0
                  ">
                    <table class="table data-table mb-0 table-customer">
                      <thead class="table-color-heading">
                        <tr style="text-align: center">
                          <th scope="col">Part No.</th>
                          <th scope="col">Section</th>
                          <th scope="col">Position</th>
                          <th scope="col">Part Name</th>
                          <th scope="col">Quality</th>
                          <th scope="col">Brand</th>
                          <th scope="col">Quantity</th>
                          <th scope="col">Unit Price</th>
                          <th scope="col">Price</th>
                          <th scope="col">Availability</th>
                          <th scope="col">Status</th>
                          <th scope="col">Created By</th>
                          <th scope="col">Created At</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="white-space-no-wrap transition-row" v-for="(pq, index) in partQuotations"
                          :key="pq.id">
                          <td class="table-font" style="text-align: center">
                            {{ pq.partNumber ? pq.partNumber : "-" }}
                          </td>
                          <td class="table-font"
                            style="text-align: center; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
                            :title="getSectionForPartQuotation(pq) || '-'">
                            <template
                              v-if="index === 0 || partQuotations[index - 1].partName !== pq.partName || partQuotations[index - 1].position !== pq.position">
                              {{ getSectionForPartQuotation(pq) || '-' }}
                            </template>
                          </td>
                          <td class="table-font" style="text-align: center">
                            <template
                              v-if="index === 0 || partQuotations[index - 1].partName !== pq.partName || partQuotations[index - 1].position !== pq.position">
                              {{ getPositionName(pq.position) }}
                            </template>
                          </td>
                          <td class="table-font" style="text-align: center">
                            <template
                              v-if="index === 0 || partQuotations[index - 1].partName !== pq.partName || partQuotations[index - 1].position !== pq.position">
                              {{ pq.partName }}
                            </template>
                          </td>
                          <td class="table-font" style="text-align: center">
                            {{ pq.quality | customTitleCase }}
                          </td>
                          <td class="table-font" style="text-align: center">
                            {{ pq.brand ? pq.brand : "-" }}
                          </td>
                          <td class="table-font" style="text-align: center">
                            {{ pq.quantity }}
                          </td>
                          <td class="table-font" style="text-align: right">
                            {{
                              pq.unitPriceSupplier.currency +
                              " " +
                              pq.unitPriceSupplier.amount.toFixed(2).toLocaleString("en-US")
                            }}
                          </td>
                          <td class="table-font" style="text-align: right">
                            {{
                              pq.priceSupplier.currency +
                              " " +
                              pq.priceSupplier.amount.toFixed(2).toLocaleString("en-US")
                            }}
                          </td>
                          <td class="table-font" style="text-align: center">
                            {{ pq.availability }}

                            <svg xmlns="http://www.w3.org/2000/svg" class="text-secondary mx-1 job-info-svg" width="20"
                              height="20" fill="blue" viewBox="0 0 24 24" stroke="currentColor"
                              @click.prevent="editPartQuotation(pq.id)" title="Edit" v-if="
                                pq.availability == 'Unavailable' && pq.status !== 'EXPIRED'
                              ">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                            </svg>
                          </td>
                          <td class="table-font" style="text-align: center">
                            {{ pq.status | customTitleCase }}
                          </td>
                          <td class="table-font" style="text-align: center">
                            {{
                              pq.createdBy.firstName +
                              " " +
                              pq.createdBy.lastName
                            }}
                          </td>
                          <td class="table-font" style="text-align: center">
                            {{ pq.createdAt | DateTimeFormat }}
                          </td>
                          <td class="table-font" style="text-align: center" v-if="pq.status !== 'EXPIRED'">
                            <svg @click="showDeletePartQuotationModal(pq.id)" style="cursor: pointer"
                              viewBox="0 0 24 24" fill="none" width="20" xmlns="http://www.w3.org/2000/svg">
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                              <g id="SVGRepo_iconCarrier">
                                <path d="M10 12V17" stroke="#ff0000" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round"></path>
                                <path d="M14 12V17" stroke="#ff0000" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round"></path>
                                <path d="M4 7H20" stroke="#ff0000" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round"></path>
                                <path d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10"
                                  stroke="#ff0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                </path>
                                <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                                  stroke="#ff0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                </path>
                              </g>
                            </svg>
                          </td>
                          <td class="table-font" style="text-align: center" v-else>
                            -
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else colspan="6" align="center">No data found</div>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
      <!-- Part Quotation -->
      <b-modal v-model="showPartQuotationModal" id="modal-part-quotation" centered title="Create New Quotation(s)"
        style="padding: 0px !important">
        <div class="row justify-content-between" style="padding: 10px; flex-wrap: initial">
          <div class="col-md-3" style="justify-content: center">
            <div class="h-display" style="padding: 10px">
              <button class="btn btn-warning btn-sm mr-2" @click="copyAllAddPartQuotationToClipboard"
                style="font-size: 16px">
                <svg v-b-tooltip.top title="Click to Copy" fill="#fff" width="20" height="20" clip-rule="evenodd"
                  fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m6 18h-3c-.48 0-1-.379-1-1v-14c0-.481.38-1 1-1h14c.621 0 1 .522 1 1v3h3c.621 0 1 .522 1 1v14c0 .621-.522 1-1 1h-14c-.48 0-1-.379-1-1zm1.5-10.5v13h13v-13zm9-1.5v-2.5h-13v13h2.5v-9.5c0-.481.38-1 1-1z"
                    fill-rule="nonzero" />
                </svg>
                Copy All
              </button>

              <button @click="deleteSelected" class="btn btn-danger btn-sm mr-2">
                <svg style="cursor: pointer" viewBox="0 0 24 24" fill="none" width="20"
                  xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path d="M10 12V17" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round">
                    </path>
                    <path d="M14 12V17" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round">
                    </path>
                    <path d="M4 7H20" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    </path>
                    <path d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10" stroke="#ffffff"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="#ffffff"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </g>
                </svg> {{ deleteButtonText }}
              </button>

              <button class="btn btn-primary btn-sm" @click="triggerPaste">
                📋 Paste Data
              </button>
            </div>
          </div>
        </div>
        <div class="table-overflow">
          <form>
            <div class="table-responsive quotation-table-wrapper">
              <table class="table table-bordered align-middle text-center excel-table">
                <thead class="table-light">
                  <tr>
                    <th style="width: 1%">
                      <input type="checkbox" v-model="allRowsSelected" @change="toggleSelectAll" />
                    </th>
                    <th style="width: 1%">Actions</th>
                    <th style="width: 30%">Part Name</th>
                    <th style="width: 12%">Position</th>
                    <th style="width: 2%">Qty.</th>
                    <th style="width: 2%">Unit Price</th>
                    <th style="width: 5%">Total Price</th>
                    <th style="width: 10%">Quality</th>
                    <th style="width: 5%">Avail. (in days)</th>
                    <th style="width: 10%">Brand</th>
                    <th style="width: 15%">Part No.</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(row, index) in quotationRows" :key="index" :class="{
                    'table-danger': row.isDuplicate,
                    'warning-border': row.invalidPrice
                  }">
                    <td>
                      <input type="checkbox" v-model="row.selected" />
                    </td>
                    <td class="">
                      <button class="btn btn-outline-secondary btn-sm" @click="duplicateRow(index)"
                        title="Duplicate this row" type="button">
                        📄
                      </button>

                    </td>
                    <td>
                      <input v-model="row.partName" class="form-control text-center" placeholder="Part Name"
                        :readonly="row.fromEnquiry || row.locked"
                        v-b-tooltip.hover.top="'This field is not editable because it comes from the enquiry'"
                        :class="{ 'readonly-cursor': row.fromEnquiry || row.locked }"
                        @input="handlePartNameChange($event, index); validateRows()" />
                    </td>

                    <td>
                      <div v-b-tooltip.hover.top="'This field is not editable because it comes from the enquiry'">
                        <select v-model="row.position" @change="handlePositionChange($event, index); validateRows()"
                          :data-row="index" :data-col="5" :disabled="row.fromEnquiry || row.locked"
                          :class="{ 'form-control readonly-cursor': row.fromEnquiry || row.locked }">
                          <option value="">Select</option>
                          <option v-for="(q, i) in partPositionArray" :key="i" :value="q.id">
                            {{ q.name }}
                          </option>
                        </select>
                      </div>
                    </td>


                    <td>
                      <input type="number" v-model.number="row.quantity" class="form-control text-center"
                        @input="handleQuantityChange($event, index); validateRows()" min="0" />
                    </td>

                    <td>
                      <input type="number" v-model.number="row.unitPrice" class="form-control text-right"
                        @input="updateTotal(index); validateRows()" min="0" />
                    </td>

                    <td class="position-relative">
                      <input type="number" v-model.number="row.totalPrice"
                        class="readonly-cursor form-control text-right readonly-field calculated-field" readonly
                        v-b-tooltip.hover.top="'This field is automatically calculated from Quantity × Unit Price'" />

                    </td>

                    <td>
                      <select v-model="row.quality" :options="qualityArray"
                        class="form-control text-center dropdown-border"
                        @input="handleQualityChange($event, index); validateRows()" :data-row="index" :data-col="5">
                        <option v-for="(q, i) in qualityArray" :key="i" :value="q">
                          {{ q }}
                        </option>
                      </select>
                    </td>

                    <td>
                      <input type="number" v-model.number="row.availability" class="form-control text-center" min="0" />
                    </td>

                    <td>
                      <input v-model="row.brand" class="form-control text-center" placeholder="Brand"
                        @input="handleBrandChange($event, index); validateRows()" />
                    </td>

                    <td>
                      <input class="form-control text-center" placeholder="Part No." v-model="row.partNumber"
                        @input="handlePartNumberChange($event, index)" />
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="duplicateError" class="alert alert-danger mt-3">
              ⚠️ {{ duplicateError }}
            </div>
            <div v-if="noEnquiryMessage" class="alert alert-warning mt-2">
              {{ noEnquiryMessage }}
            </div>

          </form>
          <div>
            <label v-if="isPartNameEmpty" class="text-danger ml-1">Part Name is required & should be less than 60
              characters</label>
          </div>
          <div>
            <label v-if="isUnitPriceEmpty" class="text-danger ml-1">Unit Price should be greater than 0</label>
          </div>
        </div>

        <div class="wrap mt-3">
          <button class="btn btn-sm btn-primary" @click="addPartQuotationRow" id="add-service" style="font-size: 16px"
            v-if="!backupQuotationRows || backupQuotationRows.length === 0">
            Add Part Quotation
          </button>
        </div>
        <template #modal-footer>
          <div style="display: block !important">
            <div v-if="totalAmount !== null" class="h-display" style="padding-right: 15px">
              <label class="form-label font-weight-bold text-right total-label">
                Total Amount
              </label>
              <div class="total-display mb-2">{{ totalAmount.toFixed(2) }} {{ order.currency }}</div>
            </div>
            <div class="w-100">
              <b-button size="sm" class="float-right btn btn-success btn-sm" @click="onSubmitPartQuotation"
                style="font-size: 16px" :disabled="duplicateError !== ''">
                Submit Quotations
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>
      <!-- Update Fully Quoted -->
      <b-modal v-model="isFullyQuotedModal" id="modal-fully-quoted" centered hide-header hide-footer>
        <div class="row" style="padding: 10px">
          <div class="col-md-12">
            <p>
              Is part quotation is "Partially Quoted" or "Fully Quoted"?
            </p>
          </div>
          <div class="col-md-6">
            <button variant="warning" size="sm" class="btn btn-warning btn-sm mr- 2 order-add"
              style="font-size: medium; cursor: pointer" @click="handlePartiallyQuoted">
              Partially Quoted
            </button>
          </div>
          <div class="col-md-6">
            <button variant="success" size="sm" class="btn btn-success float-right btn-sm order-add"
              style="font-size: medium; cursor: pointer" @click="handleFullyQuoted">
              Fully Quoted
            </button>
          </div>
        </div>
      </b-modal>
      <!-- Confirmation for Delete Part Quotation -->
      <b-modal v-model="showPartQuotationDeleteModal" id="modal-scheduled-edit" centered title="Delete Part Quotation">
        <div class="row" style="padding: 10px">
          <div class="col-md-12">
            <p>
              Are you sure you want to delete this part quotation?
            </p>
          </div>
        </div>

        <template #modal-footer>
          <div class="w-100">
            <button variant="success" size="sm" class="btn btn-success float-right btn-sm order-add"
              style="font-size: medium; cursor: pointer" @click="deletePartQuotation">
              Yes
            </button>

            <button variant="danger" size="sm" class="btn btn-danger float-right btn-sm mr-3 order-add"
              style="font-size: medium; cursor: pointer" @click="hideDeletePartQuotationModal">
              No
            </button>
          </div>
        </template>
      </b-modal>
    </div>

    <div id="load-spinner">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  PARTS_ENQUIRY_GROUP,
} from "../../../graphql/query";
import {
  ENQUIRY_GROUP_ATTACHMENTS_UPLOAD,
  WORKSHOP_PART_QUOTATION_DELETE,
  WORKSHOP_PART_QUOTATION_CREATE,
  ENQUIRY_GROUP_COMMENT_ADD,
} from "../../../graphql/mutation";
import "vue-datetime/dist/vue-datetime.css";

export default {
  name: "RFPView",
  components: {

  },
  data() {
    return {
      order: [],
      users: [],

      registrationFrontModalShow: false,
      registrationBackModalShow: false,
      approvedQuotationName: null,

      showExpired: false,
      checkedShowExpired: false,
      partQuotations: [],
      allPartQuotations: [],
      selectedPartQualities: [],
      partQualityFilterOptions: [
        { name: "Genuine", value: "GENUINE" },
        { name: "OEM", value: "OEM" },
        { name: "Aftermarket", value: "AFTERMARKET" },
      ],
      selectedCreatedBy: [],
      createdByOptions: [],
      selectedSections: [],
      sectionFilterOptions: [],
      showGeneratePdfModal: false,
      requiredChecked: false,
      required_ids: [],
      optional_ids: [],
      required_parts: [],
      optional_parts: [],
      quotation_currency: null,
      quotation_subTotal: 0,
      quotation_discount: 0,
      quotation_labour: 0,
      quotation_tax: 0,
      quotation_total_excl_tax: 0,
      quotation_total_incl_tax: 0,
      quotation_notes: "",

      is_approved: false,
      files: [],
      titles: [],

      uploadModalShow: false,
      attachments: [],

      file: null,
      fileName: null,

      modalShow: false,

      editedFieldPartPrice: null,

      comment: "",
      commentModalShow: false,

      showPartQuotationModal: false,
      showPartQuotationDeleteModal: false,
      isPartNameEmpty: false,
      isUnitPriceEmpty: false,
      is_edit: false,
      qualityArray: ["Genuine", "Aftermarket", "Used", "Service", "Consumable"],
      partPositionArray: [
        { id: "NA", name: "NA" },
        { id: "FRONT", name: "Front" },
        { id: "REAR", name: "Rear" },
        { id: "FRONT_LHS", name: "Front Left" },
        { id: "FRONT_RHS", name: "Front Right" },
        { id: "REAR_LHS", name: "Rear Left" },
        { id: "REAR_RHS", name: "Rear Right" }
      ],
      margin_pct: 0,
      // inputs: [
      //   {
      //     partNumber: "",
      //     partName: "",
      //     quality: "Genuine",
      //     brand: "",
      //     quantity: 1,
      //     unitPrice: 0,
      //     price: 0,
      //     availability: 0,
      //   },
      // ],
      isFullyQuoted: null,
      isFullyQuotedModal: false,
      pq_id: null,
      quotationRows: [],
      enquiries: [],
      duplicateError: "",
      selectAll: false,
      backupQuotationRows: [],
      noEnquiryMessage: "",

    };
  },

  mounted() {
    this.getOrderDetails();
  },
  props: ["rfpId"],
  computed: {
    totalAmount() {
      return this.quotationRows.reduce(
        (sum, row) => sum + Number(row.totalPrice || 0),
        0
      );
    },
    allRowsSelected: {
      get() {
        return this.quotationRows.length > 0 && this.quotationRows.every(row => row.selected);
      },
      set(value) {
        this.quotationRows.forEach(row => row.selected = value);
      }
    },
    deleteButtonText() {
      if (this.quotationRows.length === 0) return "Delete Selected"; // no rows
      const allSelected = this.quotationRows.every(row => row.selected);
      return allSelected ? "Delete All" : "Delete Selected";
    }
  },
  methods: {
    // loadFromEnquiries(enquiries) {
    //   // Map each enquiry into a quotation row
    //   this.quotationRows = enquiries.map((item) => ({
    //     partNumber: item.partNumber || "",
    //     partName: item.details,
    //     position: item.position,
    //     quality: item.quality || "Genuine",
    //     brand: item.brand || "",
    //     quantity: item.quantity || 1,
    //     unitPrice: item.unitPrice || 0,
    //     totalPrice: (item.quantity || 1) * (item.unitPrice || 0),
    //     availability: item.availability || 0,
    //     isDuplicate: false,
    //     invalidPrice: false,
    //     fromEnquiry: true,
    //   }));

    //   this.validateRows();

    // },

    getPositionName(id) {
      const match = this.partPositionArray.find(p => p.id === id);
      return match ? match.name : id; // fallback to id if not found
    },

    getSectionForPartQuotation(pq) {
      if (!this.order.enquiries || this.order.enquiries.length === 0) return '';

      const matchedEnquiry = this.order.enquiries.find(
        (enq) =>
          enq.details === pq.partName && enq.position === pq.position
      );

      return matchedEnquiry ? matchedEnquiry.section : '';
    },


    getPositionID(value) {
      if (!value) return "";

      const normalized = value.toString().trim().toLowerCase();

      // 1) Try by ID (REAR_LHS, FRONT, etc)
      let match = this.partPositionArray.find(
        p => p.id.toLowerCase() === normalized
      );

      // 2) Try by NAME (Rear Left, Front Right, etc)
      if (!match) {
        match = this.partPositionArray.find(
          p => p.name.toLowerCase() === normalized
        );
      }

      // 3) Fallback
      return match ? match.id : "";   // IMPORTANT → return ID for dropdown binding
    },



    toggleSelectAll() {
      this.quotationRows.forEach(row => {
        row.selected = this.allRowsSelected;
      });
    },


    deleteSelected() {
      const selectedCount = this.quotationRows.filter(r => r.selected).length;
      const totalCount = this.quotationRows.length;

      // Determine message
      let message = "";
      if (selectedCount === 0) {
        alert("No rows selected for deletion.");
        return;
      } else if (selectedCount === totalCount) {
        message = `Are you sure you want to delete ALL ${totalCount} rows? This action cannot be undone.`;
      } else {
        message = `Are you sure you want to delete the ${selectedCount} selected row(s)?`;
      }

      // Show confirmation
      if (confirm(message)) {
        // Delete logic
        this.quotationRows = this.quotationRows.filter(r => !r.selected);
        this.allRowsSelected = false; // reset header checkbox

      }

      this.validateRows();

    },


    updateTotal(index) {
      const row = this.quotationRows[index];
      row.totalPrice = (row.quantity * row.unitPrice).toFixed(2);
    },

    duplicateRow(index) {
      const original = this.quotationRows[index];
      const duplicate = JSON.parse(JSON.stringify(original)); // deep clone
      // Insert right below the original
      this.quotationRows.splice(index + 1, 0, duplicate);
      this.validateRows()
    },

    validateRows() {
      let hasError = false;
      this.duplicateError = "";

      // Reset validation flags
      this.quotationRows.forEach((r) => {
        r.isDuplicate = false;
        r.invalidPrice = false;
        r.emptyPart = false;
        r.invalidQty = false;   // ✅ NEW
      });

      for (let i = 0; i < this.quotationRows.length; i++) {
        const a = this.quotationRows[i];

        // ❌ Check empty part name
        if (!a.partName || !a.partName.trim()) {
          a.emptyPart = true;
          hasError = true;
        }

        // ❌ Validate unit price > 0
        if (!a.unitPrice || a.unitPrice <= 0) {
          a.invalidPrice = true;
          hasError = true;
        }

        // ❌ Validate qty > 0 ✅ NEW
        if (!a.quantity || a.quantity <= 0) {
          a.invalidQty = true;
          hasError = true;
        }

        // Skip duplicate check if missing name or position
        if (!a.partName || !a.position) continue;

        // 🔁 Duplicate check
        for (let j = i + 1; j < this.quotationRows.length; j++) {
          const b = this.quotationRows[j];
          if (!b.partName || !b.position) continue;

          if (
            a.partName.trim().toLowerCase() === b.partName.trim().toLowerCase() &&
            a.position.trim().toLowerCase() === b.position.trim().toLowerCase() &&
            a.unitPrice === b.unitPrice &&
            a.quality === b.quality &&
            a.brand.trim().toLowerCase() === b.brand.trim().toLowerCase()
          ) {
            a.isDuplicate = true;
            b.isDuplicate = true;
            hasError = true;
          }
        }
      }

      // 🔔 Priority error messaging
      if (this.quotationRows.some((r) => r.isDuplicate)) {
        this.duplicateError =
          "⚠️ Duplicate rows detected! Each part variation must differ by unit price, quality, or brand.";
      }
      else if (this.quotationRows.some((r) => r.emptyPart)) {
        this.duplicateError = "⚠️ Part Name is required for all rows.";
      }
      else if (this.quotationRows.some((r) => r.invalidPrice)) {
        this.duplicateError = "⚠️ Unit Price must be greater than zero.";
      }
      else if (this.quotationRows.some((r) => r.invalidQty)) {   // ✅ NEW
        this.duplicateError = "⚠️ Quantity must be greater than zero.";
      }
      else {
        this.duplicateError = "";
      }

      return !hasError;
    },

    handleShowExpired() {
      this.showExpired = this.checkedShowExpired;
      this.applyPartQuotationFilters();
    },
    handlePartQualityFilter() {
      this.applyPartQuotationFilters();
    },
    handleCreatedByFilter() {
      this.applyPartQuotationFilters();
    },
    handleSectionFilter() {
      this.applyPartQuotationFilters();
    },
    applyPartQuotationFilters() {
      // Start with all part quotations
      let filtered = [...this.allPartQuotations];

      // Apply showExpired filter
      if (!this.showExpired) {
        filtered = filtered.filter(pq => pq.status !== "EXPIRED");
      }

      // Apply quality filter
      if (this.selectedPartQualities.length > 0) {
        const selectedValues = this.selectedPartQualities.map(q => q.value);
        filtered = filtered.filter(pq => selectedValues.includes(pq.quality));
      }

      // Apply created by filter
      if (this.selectedCreatedBy.length > 0) {
        const selectedIds = this.selectedCreatedBy.map(u => u.id);
        filtered = filtered.filter(pq => selectedIds.includes(pq.createdBy?.id));
      }

      // Apply section filter
      if (this.selectedSections.length > 0) {
        filtered = filtered.filter(pq => {
          const section = this.getSectionForPartQuotation(pq);
          return this.selectedSections.includes(section);
        });
      }

      this.partQuotations = filtered;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    showToast(message, variant) {
      this.$bvToast.toast(message, {
        toaster: "b-toaster-top-center",
        variant: variant ? variant : "danger",
        solid: true,
        toastClass: "text-center toast-box toast-style",
      });
    },

    // deleteRow(index) {
    //   // Deleting Row
    //   this.inputs.splice(index, 1);
    //   this.total_amount = 0
    //   for (let i = 0; i < this.inputs.length; i++) {
    //     this.total_amount = parseFloat(
    //       parseFloat(this.total_amount) + parseFloat(this.inputs[i].price)
    //     ).toFixed(2);
    //   }
    // },
    showDeletePartQuotationModal(id) {
      this.pq_id = id;
      this.showPartQuotationDeleteModal = true;
    },
    hideDeletePartQuotationModal() {
      this.showPartQuotationDeleteModal = false;
    },
    deletePartQuotation() {
      this.$apollo
        .mutate({
          mutation: WORKSHOP_PART_QUOTATION_DELETE,
          variables: {
            id: this.pq_id,
          },
        })
        .then((data) => {
          if (data.data.workshopPartQuotationDelete.errors.length == 0) {
            if (this.is_edit == false) {
              this.showPartQuotationDeleteModal = false;
              this.showToast("Part Quotation marked as expired successfully", "success");
              this.getOrderDetails();
            }
          } else {
            this.showToast(data.data.workshopPartQuotationDelete.errors[0].message, "danger");
          }
          this.is_edit = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    copyAllAddPartQuotationToClipboard() {
      // Check if there are partQuotations in the order
      if (this.quotationRows && this.quotationRows.length > 0) {
        // Create a string to hold the copied data
        let copiedData = "Part Name\tPosition\tQuantity\tUnit Price\tTotal Price\tQuality\tAvailability\tBrand\tPart No.\t\n";
        // Loop through each partQuotation and append its data to the string
        this.quotationRows.forEach((pq) => {
          copiedData += `${pq.partName}\t${this.getPositionName(pq.position)}\t${pq.quantity}\t${pq.unitPrice}\t${pq.totalPrice}\t${pq.quality}\t${pq.availability}\t${pq.brand ? pq.brand : '-'}\t${pq.partNumber ? pq.partNumber : '-'}\n`;
        });
        // Create a textarea element to hold the copied data
        const textarea_add = document.createElement('textarea');
        textarea_add.value = copiedData;

        // Append the textarea to the DOM
        document.body.appendChild(textarea_add);

        // Select and copy the data
        textarea_add.select();
        textarea_add.focus();
        document.execCommand('copy');

        // Remove the textarea from the DOM
        document.body.removeChild(textarea_add);

        this.showToast("All the part quotations copied to clipboard!", "success");
      } else {
        this.showToast("No part quotations to copy!", "danger");
      }
    },
    copyAllPartQuotationToClipboard() {
      // Check if there are partQuotations in the order
      if (this.order.partQuotations && this.order.partQuotations.length > 0) {
        // Create a string to hold the copied data
        let copiedData = "Part No.\tPart Name\tQuality\tBrand\tQuantity\tUnit Price\tPrice\tAvailability\tCreated By\tCreated At\n";

        // Loop through each partQuotation and append its data to the string
        this.order.partQuotations.forEach((pq) => {
          copiedData += `${pq.partNumber ? pq.partNumber : '-'}\t${pq.partName}\t${pq.quality}\t${pq.brand ? pq.brand : '-'}\t${pq.quantity}\t${pq.unitPriceSupplier.currency} ${pq.unitPriceSupplier.amount}\t${pq.priceSupplier.currency} ${pq.priceSupplier.amount}\t${pq.availability}\t${pq.createdBy.firstName} ${pq.createdBy.lastName}\t${pq.createdAt}\n`;
        });

        // Create a textarea element to hold the copied data
        const textarea = document.createElement('textarea');
        textarea.value = copiedData;

        // Append the textarea to the DOM
        document.body.appendChild(textarea);

        // Select and copy the data
        textarea.select();
        document.execCommand('copy');

        // Remove the textarea from the DOM
        document.body.removeChild(textarea);

        this.showToast("All part quotations copied to clipboard!", "success");
      } else {
        this.showToast("No part quotations to copy!", "danger");
      }
    },
    addPartQuotationRow() {
      this.quotationRows.push({
        partNumber: "",
        partName: "",
        section: "",
        quantity: 1,
        position: "NA",
        unitPrice: 0,
        totalPrice: 0,
        quality: "Genuine",
        brand: "",
        availability: 0,
        isDuplicate: false,
        invalidPrice: false,
        fromEnquiry: false,
        selected: false,
      });

      this.noEnquiryMessage = "";
      this.validateRows();
    },
    addPartQuotation() {
      this.showPartQuotationModal = true;
      this.isPartNameEmpty = false;
      this.isUnitPriceEmpty = false;
      // this.total_amount = 0;
      this.quotationRows = this.enquiries.map((item) => ({
        partNumber: item.partNumber || "",
        partName: item.details,
        section: item.section || "",
        quantity: item.quantity,
        position: item.position,
        unitPrice: item.unitPrice || 0,
        totalPrice: (item.quantity || 1) * (item.unitPrice || 0),
        quality: item.quality || "Genuine",
        brand: item.brand || "",
        availability: item.availability || 0,
        isDuplicate: false,
        invalidPrice: false,
        fromEnquiry: true,
        selected: false,
      }));

      this.backupQuotationRows = JSON.parse(JSON.stringify(this.quotationRows));


      if (!this.backupQuotationRows || this.backupQuotationRows.length === 0) {
        this.noEnquiryMessage = "No enquiries. Add enquiries to quote.";
      } else {
        this.noEnquiryMessage = "";
      }

      this.validateRows();

    },

    async triggerPaste() {
      try {
        // ✅ Try modern clipboard API first
        if (navigator.clipboard && window.isSecureContext) {
          const text = await navigator.clipboard.readText();
          if (!text) {
            alert("Clipboard is empty!");
            return;
          }
          this.handlePaste(text);
          return;
        }

        // 🚨 If no permission or not HTTPS → fallback
        this.manualPasteFallback();

      } catch (err) {
        console.error("Clipboard read failed:", err);
        this.manualPasteFallback();
      }
    },

    manualPasteFallback() {
      const input = document.createElement("textarea");
      input.style.position = "fixed";
      input.style.opacity = 0;
      input.style.pointerEvents = "none";
      document.body.appendChild(input);
      input.focus();

      // Listen for paste event
      input.addEventListener("paste", (e) => {
        e.preventDefault();
        const pastedData = (e.clipboardData || window.clipboardData).getData("text");
        if (pastedData) {
          this.handlePaste(pastedData);
        } else {
          alert("No data found in clipboard.");
        }

        document.body.removeChild(input); // cleanup
      });
    },

    handlePaste(pastedData) {
      if (!pastedData) return;

      // Split rows & columns
      let rows = pastedData
        .trim()
        .split(/\r?\n/)
        .map(row => row.split("\t"));

      // Normalize headers to detect heading row
      const normalize = (str) =>
        str.replace(/\./g, "").replace(/\s+/g, "").toLowerCase();

      const expectedHeadings = [
        "partname",
        "position",
        "quantity",
        "unitprice",
        "totalprice",
        "quality",
        "availability",
        "brand",
        "partno"
      ];

      const firstRow = rows[0].map(v => normalize(v));
      const matchedCount = expectedHeadings.filter(h => firstRow.includes(h)).length;
      const hasHeadings = matchedCount >= 2;

      if (hasHeadings) rows = rows.slice(1);

      // Clear existing
      this.quotationRows = [];

      const enquiryRows = Array.isArray(this.backupQuotationRows)
        ? this.backupQuotationRows
        : [];

      let ignored = 0;
      let added = 0;

      // Normalize function
      const normalizeText = (txt) =>
        txt.toLowerCase().replace(/\s+/g, " ").trim();

      rows.forEach((rowData) => {

        // Extract raw values
        const partName = (rowData[0] || "").trim();
        const rawPosition = (rowData[1] || "").trim();

        const quantity = parseFloat(rowData[2]) || 0;
        const unitPrice = rowData[3]
          ? Math.max(0, parseFloat(rowData[3].replace(/[^\d.-]+/g, "")))
          : 0;

        const totalPrice = (quantity * unitPrice).toFixed(2);

        const availMatch = rowData[6] && rowData[6].match(/-?\d+/);
        const availability = availMatch
          ? Math.max(0, parseInt(availMatch[0], 10))
          : 0;

        // ✅ Convert pasted position -> ID
        const pastedPositionId = this.getPositionID(rawPosition);

        const newRow = {
          partName,
          position: pastedPositionId,
          quantity,
          unitPrice,
          totalPrice,
          quality: rowData[5] || "Genuine",
          availability,
          brand: rowData[7] || "",
          partNumber: rowData[8] || "",
          fromEnquiry: false,
          locked: true,
          selected: false,
        };

        this.noEnquiryMessage = "";

        // ✅ MATCH TO ENQUIRY
        if (enquiryRows.length > 0) {

          const matched = enquiryRows.find((r) => {
            const enquiryPositionId = this.getPositionID(r.position);

            return (
              normalizeText(r.partName || "") === normalizeText(partName) &&
              enquiryPositionId === pastedPositionId
            );
          });

          if (matched) {
            this.quotationRows.push(newRow);
            added++;
          } else {
            ignored++;
          }

        } else {
          // No enquiries → allow all
          this.quotationRows.push(newRow);
          added++;
        }

      });

      // ✅ Recalculate total
      this.total_amount = this.quotationRows
        .reduce((sum, r) => sum + (parseFloat(r.totalPrice) || 0), 0)
        .toFixed(2);

      // ✅ Alerts
      if (enquiryRows.length) {
        if (ignored && added)
          alert(`⚠️ Ignored ${ignored} out of ${rows.length} pasted rows (no matching enquiry found).`);
        else if (ignored && !added)
          alert(`❌ None of the pasted rows matched existing enquiries.`);
        else
          alert(`✅ Successfully pasted ${added} rows (all matched enquiries).`);
      } else {
        alert(`✅ Pasted ${added} rows successfully (no enquiries to match).`);
      }

      this.validateRows();
    },


    handlePartNameChange(e, index) {
      this.quotationRows[index].partName = e.target.value;
    },
    handleQuantityChange(e, index) {
      this.quotationRows[index].quantity = e.target.value;
      this.quotationRows[index].price = parseFloat(
        parseFloat(this.quotationRows[index].unitPrice) *
        parseFloat(this.quotationRows[index].quantity)
      ).toFixed(2);
      this.updateTotal(index)
    },
    handlePositionChange(e, index) {
      this.quotationRows[index].position = e.target.value;
    },
    handleQualityChange(e, index) {
      this.quotationRows[index].quality = e.target.value;
    },
    handleAvailabilityChange(e, index) {
      this.quotationRows[index].availability = e.target.value;
    },
    handleBrandChange(e, index) {
      this.quotationRows[index].brand = e.target.value;
    },
    handlePartNumberChange(e, index) {
      this.quotationRows[index].partNumber = e.target.value;
    },
    hideFullyQuotedModal() {
      this.isFullyQuotedModal = false;
    },
    onSubmitPartQuotation() {
      this.validateRows();
      if (this.duplicateError) {
        alert("Please fix duplicate entries before submitting.");
        return;
      }

      this.isFullyQuotedModal = true;
      this.isFullyQuoted = null;

    },
    handlePartiallyQuoted() {
      this.isFullyQuoted = false;
      this.handleCreatePartQuotation();
    },
    handleFullyQuoted() {
      this.isFullyQuoted = true;
      this.handleCreatePartQuotation();
    },
    handleCreatePartQuotation() {
      let toastText = "";
      if (this.isFullyQuoted == null) {
        toastText = "Please update quoted status";
      }
      if (toastText) {
        this.showToast(toastText, "danger");
      }
      let partinputs = [];
      if (this.isPartNameEmpty == false && this.isUnitPriceEmpty == false) {
        this.quotationRows.map((input) => {
          partinputs.push({
            partNumber: input.partNumber,
            partName: input.partName,
            quality: input.quality.toUpperCase(),
            brand: input.brand,
            quantity: input.quantity,
            priceSupplier: input.totalPrice,
            availability: input.availability,
            position: input.position,
            section: input.section,
          });
        });
        this.$apollo
          .mutate({
            mutation: WORKSHOP_PART_QUOTATION_CREATE,
            variables: {
              enquiryGroupId: this.rfpId,
              input: partinputs,
              isFullyQuoted: this.isFullyQuoted,
            },
          })
          .then((data) => {
            if (data.data.workshopPartQuotationsCreate.errors.length == 0) {
              this.isFullyQuotedModal = false;
              this.showPartQuotationModal = false;
              this.showToast("Part Quotation Created Successfully", "success");
              this.quotationRows = [
                {
                  partNumber: "",
                  partName: "",
                  section: "",
                  quantity: 1,
                  position: "NA",
                  unitPrice: 0,
                  totalPrice: 0,
                  quality: "Genuine",
                  brand: "",
                  availability: 0,
                  isDuplicate: false,
                  invalidPrice: false,
                  fromEnquiry: false,
                  selected: false,
                },
              ];
              this.showPartQuotationModal = false;
              this.order.partQuotations = data.data.workshopPartQuotationsCreate.partQuotations;
              this.order.isFullyQuoted = data.data.workshopPartQuotationsCreate.isFullyQuoted;
              this.allPartQuotations = [...data.data.workshopPartQuotationsCreate.partQuotations];
              this.applyPartQuotationFilters();

            } else {
              this.errors = data.data.workshopPartQuotationsCreate.errors;
              this.errors.map((e) => {
                this.showToast(e.message, "danger");
              });
            }
          });
      }
    },

    async getOrderDetails() {
      document.getElementById("load-spinner").style.display = "flex";
      document.getElementById("main-div").style.display = "none";
      await this.$apollo
        .query({
          query: PARTS_ENQUIRY_GROUP,
          variables: {
            id: this.rfpId,
          },
        })
        .then((data) => {
          this.notes = [];
          document.getElementById("load-spinner").style.display = "none";
          document.getElementById("main-div").style.display = "block";
          if (data.data.workshopEnquiryGroup) {
            this.datetime = data.data.workshopEnquiryGroup.createdAt;

          }
          this.order = data.data.workshopEnquiryGroup;
          this.order.partQuotations = data.data.workshopEnquiryGroup.partQuotations;

          // Store all part quotations for filtering
          this.allPartQuotations = [...data.data.workshopEnquiryGroup.partQuotations];

          // Populate createdBy options
          const createdByMap = new Map();
          this.allPartQuotations.forEach(pq => {
            if (pq.createdBy) {
              createdByMap.set(pq.createdBy.id, {
                id: pq.createdBy.id,
                name: `${pq.createdBy.firstName} ${pq.createdBy.lastName}`.trim()
              });
            }
          });
          this.createdByOptions = Array.from(createdByMap.values());

          // Populate section options from enquiries
          const sectionsSet = new Set();
          data.data.workshopEnquiryGroup.enquiries.forEach(enq => {
            if (enq.section) {
              sectionsSet.add(enq.section);
            }
          });
          this.sectionFilterOptions = Array.from(sectionsSet).sort();

          this.enquiries = data.data.workshopEnquiryGroup.enquiries;

          // Apply filters to show initial filtered list
          this.applyPartQuotationFilters();
        });
    },

    handleRegistrationCardFront() {
      this.registrationFrontModalShow = true;
    },
    handleRegistrationCardBack() {
      this.registrationBackModalShow = true;
    },

    createTable(id) {
      var tabContent = document.getElementById("tab-content");
      if (id === "PICKUP") {
        var table = document.createElement("table");
        table.classList.add("tab-pane fade in active");
      }
      for (var i = 1; i < 4; i++) {
        var tr = document.createElement("tr");

        var td1 = document.createElement("td");
        var td2 = document.createElement("td");

        var text1 = document.createTextNode(id);
        var text2 = document.createTextNode("Text2");

        td1.appendChild(text1);
        td2.appendChild(text2);
        tr.appendChild(td1);
        tr.appendChild(td2);

        table.appendChild(tr);
      }

      tabContent.appendChild(table);
    },


    handleUpload() {
      this.files = [];
      this.titles = [];
      this.is_show = false;
      this.type = false;
      this.is_approved = false;
      this.uploadModalShow = true;
    },

    handleFileUpload({ target }) {
      for (var i = 0; i < target.files.length; i++) {
        this.files.push(target.files[i]);
        this.titles.push(target.files[i].name);
      }
    },

    removeImage(index) {
      this.files.splice(index, 1);
      this.titles.splice(index, 1);
    },
    orderUpload() {
      if (this.files && this.files.length > 0) {
        this.uploadModalShow = false;

        document.getElementById("main-div").style.display = "none";
        document.getElementById("load-spinner").style.display = "flex";
        this.$apollo
          .mutate({
            mutation: ENQUIRY_GROUP_ATTACHMENTS_UPLOAD,
            variables: {
              enquiryGroupId: this.rfpId,
              files: this.files,
              titles: this.titles,
            },

          })
          .then((data) => {
            document.getElementById("main-div").style.display = "block";
            document.getElementById("load-spinner").style.display = "none";

            if (data.data.egAttachmentsUpload.errors.length == 0) {
              this.showToast("Uploaded successfully", "success");
              this.getOrderDetails();

            } else {
              this.errors = data.data.egAttachmentsUpload.errors;
              this.errors.map((e) => {
                this.showToast(`${e.message}`, "danger");
              });
            }
          });
      } else {
        this.showToast(`Please select file to upload`, "danger");
      }
    },

    handleComment() {
      this.comment = null;
      this.commentModalShow = true;
    },
    commentUpdate() {
      if (this.comment == null || this.comment == "") {
        this.showToast("Comment is required", "danger");
      } else {
        this.commentModalShow = false;
        document.getElementById("main-div").style.display = "none";
        document.getElementById("load-spinner").style.display = "flex";
        this.$apollo
          .mutate({
            mutation: ENQUIRY_GROUP_COMMENT_ADD,
            variables: {
              enquiryGroupId: this.rfpId,
              comment: this.comment,
            },
          })
          .then((data) => {
            document.getElementById("main-div").style.display = "block";
            document.getElementById("load-spinner").style.display = "none";
            this.isWhisper = false;
            if (data.data.enquiryGroupCommentCreate.errors.length == 0) {
              this.showToast("Comment added successfully", "success");
            } else {
              this.errors = data.data.enquiryGroupCommentCreate.errors;
              this.errors.map((e) => {
                this.showToast(`${e.message}`, "danger");
              });
            }
            this.getOrderDetails();
            // this.enquiries.comments = {};
            // this.enquiries.comments = data.data.enquiryGroupCommentCreate.comment;
          });
      }
    },

    copyIdToClipboard(id) {
      // Create a temporary input element
      var input = document.createElement("textarea");
      input.value = id.trim(); // Remove leading/trailing spaces
      document.body.appendChild(input);

      // Select the text within the input
      input.select();
      input.setSelectionRange(0, 99999); // For mobile devices

      // Copy the selected text to the clipboard
      document.execCommand("copy");

      // Clean up by removing the input element
      document.body.removeChild(input);

      var message = "Copied";
      this.showToast("Order Number : " + id + " " + `${message}`, "success");
    },

    copyTextToClipboard(id, text) {
      // Create a temporary input element
      var input = document.createElement("textarea");
      input.value = id.trim(); // Remove leading/trailing spaces
      document.body.appendChild(input);

      // Select the text within the input
      input.select();
      input.setSelectionRange(0, 99999); // For mobile devices

      // Copy the selected text to the clipboard
      document.execCommand("copy");

      // Clean up by removing the input element
      document.body.removeChild(input);

      var message = "Copied";
      this.showToast(text + ": " + id + " " + `${message}`, "success");
    },

  },
};
</script>

<style>
.navigation-link-text {
  color: blue;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
}

.hide-data-list {
  display: none;
}

.assigned-to-custom {
  font-size: 20px;
  cursor: pointer;
  position: absolute;
  top: 40%;
  right: 10%;
  z-index: 1;
  transform: translate(0%, -50%);
}

.job-info-svg {
  cursor: pointer;
  margin-bottom: 0.1rem;
}

.job-info-svg:hover {
  fill: blue;
}

.cancel-order:hover {
  background-color: red;
  border-color: red;
}

.sumbit-order:hover {
  background-color: green;
  border-color: green;
}

.transition-row {
  transition: transform 0.1s;
}

.transition-row:hover {
  background-color: rgb(245, 245, 245);
}

.toast-style {
  font-size: 1.2rem;
  padding: 1rem;
}

.text-area-clipboard {
  border: none;
  color: white;
  height: 0;
  width: 0;
}

.divScroll {
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  max-height: 200px;
  overflow-y: scroll;
  padding: 10px;
}

.edit-btn:disabled {
  cursor: not-allowed !important;
}

.commentScroll {
  display: block;
  flex-wrap: wrap;
  max-width: 100%;
  max-height: 240px;
  overflow-y: scroll;
  padding: 10px;
}

.custom-input {
  display: block;
  width: 100%;
  padding: 0.375em 0.75em;
  font-size: 1em;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25em;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-sizing: border-box;
}

.custom-input-discount {
  text-align: right;
  padding: 0.375em 0.75em;
  max-width: 105px;
  font-size: 1em;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25em;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-sizing: border-box;
}

/* .card-body {
  padding: 0px;
} */
.card .card-header {
  padding: 10px;
}

.custom-input {
  display: block;
  width: 100%;
  padding: 0.375em 0.75em;
  font-size: 1em;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25em;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-sizing: border-box;
}

.custom-input-resize {
  display: block;
  text-align: right;
  width: 110px !important;
  padding: 0.375em 0.75em;
  font-size: 1em;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25em;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-sizing: border-box;
}

.custom-input-labour {
  display: block;
  text-align: left;
  width: 140px !important;
  padding: 0.375em 0.75em;
  font-size: 1em;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25em;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-sizing: border-box;
}

.table-overflow {
  padding: 10px;
  overflow: visible;
}

.inputWrapper {
  overflow: hidden;
  position: relative;
  cursor: pointer;
}

.fileInput {
  cursor: pointer;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  /*This makes the button huge so that it can be clicked on*/
  font-size: 50px;
}

.hidden {
  /*Opacity settings for all browsers*/
  opacity: 0;
  -moz-opacity: 0;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);
}

.btn-history {
  background-color: #888;
  border: 1px solid #888;
  color: #fff;
  cursor: pointer;
}

.btn-history:hover {
  background-color: #515151;
  border: 1px solid #515151;
  color: #fff;
}

.divScroll {
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  max-height: 200px;
  overflow-y: scroll;
  padding: 15px;
}

.img-tag {
  padding: 5px;
  margin: 3px;
  background-color: #80808038;
  border-radius: 15px;
}

#tab-content .seconds-span {
  position: absolute;
  right: 100px;
  top: 20px;
}

#tab-content .daysCounter {
  /* position: absolute;
    right: 55%;
    top: 20px; */

  position: relative;
  left: 30%;
  bottom: 40px;
}

#tab-content table tr {
  border: hidden;
}

#tab-content .clock-div-vl {
  border-left: 5px solid green;
  height: 30px;
  transform: translate(38%);
}

#tab-content .tick-div-vl {
  border-left: 5px solid green;
  height: 70px;
  transform: translate(38%);
}

#tab-content tr {
  font-size: 14px;
}

#payment-id {
  display: none;
}

#additional-payment-id {
  display: none;
}

.text-monospace {
  font-family: monospace, monospace !important;
  text-align: right;
}

.scheduled-at-edit .vdatetime-popup {
  width: 280px;
}

.scheduled-at-edit .custom-input {
  width: 100%;
}

.scheduled-at .custom-input {
  width: 100%;
}

.scheduled-at .vdatetime-popup {
  width: 280px;
}

/* .scheduled-at .vdatetime-time-picker__list--minutes {
  display: none !important;
}

.scheduled-at .vdatetime-time-picker__with-suffix .vdatetime-time-picker__list {
  width: 50%;
} */

#modal-scheduled .modal-dialog {
  max-width: 300px;
}

#modal-scheduled-edit .modal-dialog {
  max-width: 300px;
}

#modal-staffNote-edit .modal-dialog {
  max-width: 400px;
}

#load-spinner {
  justify-content: center;
  display: none;
}

/* pre{
  display: block;
  font-size: 80.5%;
  color: #212529;
} */

.pre {
  padding: 2px 0px;
  font-size: 15px;
}

.is-paid {
  border: 2px solid #099909;
  border-radius: 4px;
  font-weight: 600;
  font-size: 13px;
  padding: 5px;
  background: #099909;
  color: white !important;
}

.is-unpaid {
  border: 2px solid #f42b3d;
  border-radius: 4px;
  font-weight: 600;
  font-size: 13px;
  padding: 5px;
  background: #f42b3d;
  color: white !important;
}

.is-auth {
  border: 2px solid #e2ac20;
  border-radius: 4px;
  font-weight: 600;
  font-size: 13px;
  padding: 4px;
  background: #e2ac20;
  color: white !important;
}

.img-fluid {
  max-width: 100%;
  height: 80px;
}

.is-unauth {
  margin: 0px 5px;
  border: 2px solid #f42b3d;
  border-radius: 4px;
  font-weight: 600;
  font-size: 13px;
  padding: 4px;
  background: #f42b3d;
  color: white !important;
}

.attachement-card .card-body,
.job-card .card-body {
  padding: 0px !important;
}

.divScrollNotes {
  overflow-y: scroll;
  max-height: 100px;
}

.table>tbody>tr>.thick-line {
  border-top: 1px solid;
}

.mobile-view-attachment,
.mobile-view-payment {
  display: none;
}

.desktop-view-attachment,
.desktop-view-payment {
  display: block;
}

/* click animation */

.flashBG {
  animation-name: flash;
  animation-timing-function: ease-out;
  animation-duration: 1s;
}

.cursor-pointer {
  cursor: pointer;
}

.table td {
  padding: 0.75rem !important;
}

.remove-button-custom {
  font-size: 20px;
  cursor: pointer;
  position: absolute;
  top: 40%;
  right: 15%;
  z-index: 1;
  transform: translate(0%, -50%);
}

.pac-container {
  z-index: 1100 !important;
}

.pac-target-input {
  background: none padding-box rgb(255, 255, 255);
  border: 2px solid #ec008c;
  padding: 0px 28px;
  cursor: pointer;
  direction: ltr;
  overflow: hidden;
  height: 40px;
  color: rgb(86, 86, 86);
  font-size: 18px;
  box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
  border-radius: 5px;
  position: absolute;
  top: 26px;
  width: 50%;
  right: 17%;
  z-index: 1;
}



.staff-note-btn {
  float: right;
}

.editable-field {
  margin: 10px 0;
}

.editable-field input,
.editable-field button {
  padding: 0px 4px;
  font-size: 12px;
}

.edit-label {
  color: #e78924 !important;
  /* font-weight: 500; */
}

#frontModal .modal-body {
  padding: 0px !important;
}

#backModal .modal-body {
  padding: 0px !important;
}

#modal-center-location .modal-footer {
  display: none;
}

#modal-part-quotation___BV_modal_body_ .multiselect__content-wrapper,
#modal-part-quotation___BV_modal_body_ .multiselect__tags {
  min-width: 120px;
  max-width: 160px;
}

.editable-field .multiselect__element span span,
.editable-field .multiselect__single {
  font-size: 12.5px;
}

.quality-dropdown .multiselect__content-wrapper {
  position: relative;
  z-index: 9999;
}

.editable-field .search-input {
  font-size: 11px;
}

.editable-field .single-select-wrapper {
  width: 180px;
}

.editable-field li {
  font-size: 11.5px;
}

.editable-field .custom-control {
  position: inherit;
  min-height: 27px;
}

.orange-highlight {
  background-color: #ffa5007a !important;
}

#modal-center-invoice .modal-footer,
#modal-center-cancel .modal-footer,
#modal-center-fulfill .modal-footer {
  display: none !important;
}

.notes,
.comments {
  overflow-y: auto;
  white-space: pre-wrap;
  width: 100%;
}

.notes {
  max-height: 60px;
}

/* Ensures horizontal scrolling on smaller devices */
.quotation-table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Prevents input squishing */
/* .excel-table input,
.excel-table select {
  min-width: 120px;
} */

/* Makes table cells align nicely */
.excel-table th,
.excel-table td {
  white-space: nowrap;
  vertical-align: middle;
}

/* Optional: shrink button column */
/* .excel-table th:last-child,
.excel-table td:last-child {
  width: 50px;
  text-align: center;
} */

.excel-table input,
.excel-table select {
  width: 100%;
  border: none;
  outline: none;
  text-align: center;
  padding: 6px 4px;
  background: transparent;
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
}

/* make dropdowns visibly different from inputs */
.excel-table select {
  appearance: none;
  /* removes default browser styles */
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #f9fbff url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6'><path fill='gray' d='M0 0l5 6 5-6z'/></svg>") no-repeat right 8px center;
  background-size: 10px 6px;
  padding-right: 20px;
  /* space for dropdown arrow */
  border-radius: 4px;
  cursor: pointer;
}

.excel-table select:hover {
  background-color: #eef4ff;
}

.excel-table select:focus {
  background-color: #e6f4ff;
  outline: 1px solid #0078d4;
}

.excel-table input:focus {
  background: #eef9ff;
  outline: 1px solid rgba(0, 120, 212, 0.18);
}

.table-danger {
  background-color: #f8d7da !important;
}

.alert {
  font-size: 14px;
  padding: 8px 12px;
}

select:disabled,
button:disabled,
textarea:disabled,
input:disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
}

input[readonly] {
  background-color: #f8f9fa;
  cursor: not-allowed;
}

#modal-part-quotation .modal-footer {
  justify-content: center;
}

.readonly-cursor {
  background-color: #f0f0f0 !important;
  /* light grey */
  border: 1px solid #d0d0d0 !important;
  /* darker border */
  cursor: not-allowed !important;
  color: #555 !important;
  /* slightly dimmer text */

}

td .readonly-cursor,
td .readonly-cursor:hover {
  cursor: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3E%3Ccircle cx='12' cy='12' r='11' fill='red' stroke='white' stroke-width='2' /%3E %3Crect x='4' y='10.5' width='16' height='3' fill='white' /%3E %3C/svg%3E") 10 12, not-allowed !important;
}

table.excel-table tr.warning-border {
  background-color: transparent !important;
  border: 2px solid red;
  /* Bootstrap warning color */
}

.dropdown-border {
  border: 1px solid #e9ecef !important;
}

@keyframes flash {
  0% {
    background: #28a745;
  }

  100% {
    background: transparent;
  }
}

.radio-input {
  display: flex !important;
}

.st0 {
  fill: #000000;
}

@media (max-width: 767px) {
  .table {
    display: table !important;
  }
}

@media only screen and (max-width: 768px) {

  .mobile-view-attachment,
  .mobile-view-payment {
    display: block;
  }

  .desktop-view-attachment,
  .desktop-view-payment {
    display: none;
  }
}

@media (min-width: 576px) {
  #modal-part-quotation .modal-dialog {
    max-width: none !important;
  }
}

@media only screen and (max-width: 450px) {

  #tab-content .table th,
  .table td {
    padding: 4px 5px;
  }

  #tab-content tr {
    font-size: 12px;
  }

  #tab-content .daysCounter {
    position: relative;
    left: 7%;
    bottom: 47px;
  }

  .radio-input {
    display: block !important;
  }
}
</style>